import { SlideComponentCharacter } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentCharacterCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentCharacter {
        return {
            id: id,
            type: 'character',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 200, height: 200 },
            content: {
                image: '',
                characterList: [],
                character: 0,
                characterSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phrase: '',
                phraseSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phraseSoundGroup: {
                    jyutping: [
                        {
                            startIndex: 0,
                        },
                    ],
                    pinyin: [
                        {
                            startIndex: 0,
                        },
                    ],
                },
                imageURL: '',
                gameType: 'Writing',
                flip: 1,
            },
        };
    }
}
